module.exports = __webpack_public_path__ + "img/servicos-color.f6c4c3ac.svg";